import axios from 'axios'
import Vue from 'vue'
import router from '@/router'
// 创建 axios 实例
// axios.defaults.withCredentials = true; // 允许携带cookie
// axios.defaults.timeout = 20000;
console.log(process.env.NODE_ENV)
// let baseURL = 'http://59.110.143.238:21104'
let baseURL = '';
console.log(window.location.href)
let u = window.location.href;
let h = u.split("/")[0]; //http
let a = u.split("/")[2]; //ip
let ha = h+"//"+a
if (process.env.NODE_ENV == 'development') {
  baseURL = '/api'
} else {
  baseURL = ha
}
const request = axios.create({
  // API 请求的默认前缀
  baseURL: baseURL,
  timeout: 600000, // 请求超时时间
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  }
})

// request拦截器
request.interceptors.request.use(
  (config) => {
    console.log(Vue.cookie)
    // config.headers['token'] = Vue.cookie.get('token')
    //   ? Vue.cookie.get('token')
    //   : '74c8ffe4a59da108f03aa7afc77cc24e'
      // config.headers['token'] ='74c8ffe4a59da108f03aa7afc77cc24e'

      const token = localStorage.getItem('OAtoken')
  // 让每个请求携带自定义 token 
  // 如果 token 存在
  if (token) {
    // config.headers['Access-Token'] = token
    config.headers['authorization'] = token
  }
    return config
  },
  (error) => {
    return Promise.reject(error)
  })
 
// response拦截器
request.interceptors.response.use(response => {
  if (response.data && response.data.code === 401) { // 401, token失效
    Vue.cookie.delete('token')
    router.push({name: 'HomePage'})
  }
  return response
}, error => {
  return Promise.reject(error)
})
export default request


// WEBPACK FOOTER //
// ./src/utils/request.js